export default "__VITE_ASSET__C1pZm6Qe__"